export const namespaced = true
import Enums from '../../helpers/Enums'
import ProjectsService from '../../services/ProjectsService'

const initialState = {
  project: {},
  selectedMasterplan: null,
  selectedBuilding: null,
  contentData: null
}
export const state = {
  project: {},
  selectedMasterplan: null,
  selectedBuilding: null,
  contentData: null
}
let nextId = 1
export const mutations = {
  SET_SELECTED_MASTERPLAN(state, data) {
    state.selectedMasterplan = data
  },
  SET_ALL_CONTENT_DATA(state, data) {
    state.contentData = data
  },
  SET_SELECTED_BUILDING(state, data) {
    state.selectedBuilding = data
  },
  RESET_STORE(state) {
    Object.assign(state, initialState)
  }
}

export const actions = {
  async getAllContentData(context) {
    let resp = await ProjectsService.getProjectFullStructure(3) //TODO should get root projectId from config
      .catch(e => {
        console.error(e)
      })
      .finally(console.log('Got all content data!'))
    context.commit('SET_ALL_CONTENT_DATA', resp.data)
    context.dispatch(
      'setSelectedMasterplan',
      context.getters.getMasterplanById(3) //TODO should get root masterplanId from config
    )
  },
  setSelectedMasterplan(context, data) {
    context.commit('SET_SELECTED_MASTERPLAN', data)
  },
  setSelectedBuilding(context, data) {
    context.commit('SET_SELECTED_BUILDING', data)
  },
  resetStore: async function(context) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    context.commit('RESET_STORE')
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  }
}

export const getters = {
  getMasterplanById: state => id => {
    return findMasterplanById(state.contentData.Masterplans, id)
  },
  getSelectedMasterplanTitle: (state, getters) => {
    return getters.getMasterplanTitle(state.selectedMasterplan)
  },
  getSelectedMasterplanChildren: state => {
    return state.selectedMasterplan.Masterplans
  },
  getSelectedMasterplanInfoPoi: state => {
    return getters.getMasterplanInfoPoi(state.selectedMasterplan)
  },
  getSelectedMasterplanPois: state => {
    return state.selectedMasterplan.Pois.filter(
      p => p.poiTypeId === Enums.PoiType.poi_type_masterplan
    )
  },
  getSelectedMasterplanImages: (state, getters) => {
    const images = getters.getMasterplanImages(state.selectedMasterplan)
    console.log('images', images)
    return images
  },
  getMasterplanTitle: (state, getters) => masterplan => {
    const infoPoi = getters.getMasterplanInfoPoi(masterplan)
    let titleMedia = infoPoi.Media.find(
      m =>
        m.mediaTypeId === Enums.MediaType.poi_text_title_and_description &&
        m.langId === 1 //TODO Should pickup langId from global config
    )
    if (!titleMedia) return masterplan.name
    return titleMedia.textualContent
  },
  getMasterplanInfoPoi: state => masterplan => {
    return masterplan.Pois.find(
      p => p.poiTypeId === Enums.PoiType.poi_type_masterplan_info
    )
  },
  getMasterplanImages: (state, getters) => masterplan => {
    const infoPoi = getters.getMasterplanInfoPoi(masterplan)
    console.log('getMasterplanImages', infoPoi.Media)
    return infoPoi.Media.filter(
      m => m.mediaTypeId === Enums.MediaType.poi_image && m.langId === 1
    ) //TODO Should pickup langId from global config
  },
  getMediaFilePath: (state, getters) => media => {
    return `/pois/${media.PoiContent.poisId}/media-content/${media.id}/file`
  },
  getPoiData: state => poi => {
    const media = poi.Media.find(m => {
      return m.mediaTypeId === Enums.MediaType.poi_data
    })
    if (!media) {
      return { masterplanId: 0 }
      //TODO The default poiData return if none found should always be the same and defined in config
      //TODO also, should probably depend on poi type
    }
    return media.mediaData
  },
  getMasterplanBuldingById: state => (masterplan, buildingId) => {
    if (masterplan.Buildings.length === 0) return null
    return masterplan.Buildings.find(b => b.id === buildingId)
  },
  getBuildingTitle: (state, getters) => building => {
    const infoPoi = getters.getBuildingInfoPoi(building)
    let titleMedia = infoPoi.Media.find(
      m =>
        m.mediaTypeId === Enums.MediaType.poi_text_title_and_description &&
        m.langId === 1 //TODO Should pickup langId from global config
    )
    if (!titleMedia) return building.name
    return titleMedia.textualContent
  },
  getBuildingInfoPoi: (state, getters) => building => {
    return building.Pois.find(
      p => p.poiTypeId === Enums.PoiType.poi_type_building
    )
  },
  getBuildingImages: (state, getters) => building => {
    const infoPoi = getters.getBuildingInfoPoi(building)
    if (infoPoi.length === 0) return []
    return infoPoi.Media.filter(
      m => m.mediaTypeId === Enums.MediaType.poi_image && m.langId === 1
    ) //TODO Should pickup langId from global config
  },
  getBuildingApartments: (state, getters) => building => {
    return building.Apartments
  }
}

const findMasterplanById = (masterplans, id) => {
  for (const m of masterplans) {
    if (m.id === id) return m
    if (
      // eslint-disable-next-line no-prototype-builtins
      m.hasOwnProperty('Masterplans') &&
      Array.isArray(m.Masterplans) &&
      m.Masterplans.length > 0
    ) {
      return findMasterplanById(m.Masterplans, id)
    }
  }
  return null
}
